﻿import $ from "jquery";

function Qstring(qs) {
	///	<summary>
	///	$.qstring([qs]) - creates querystring object
	///	</summary>
	///	<param name="qs" type="String">
	///	<returns type="$.qstring" />
	if(this === $)
		return new Qstring(qs);
	this.parse(qs);
}

Qstring.prototype = {

	each: function(f) {
		///	<summary>
		///	each(f) - iterates over querystring items, calling function f on each
		///	</summary>
		///	<param name="f" type="Function">
		x: for(var key in this.p) {
			var y = this.p[key];
			for(var i = 0; i < y.length; i++)
				if(f(key, y[i]) === false)
					break x;
		}
		return this;
	},

	exists: function(name) {
		///	<summary>
		///	exists(name) - checks whether parameter exists
		///	</summary>
		///	<param name="name" type="String">
		///	<returns type="Boolean" />
		return this.p[name] != null;
	},

	get: function(name, defval) {
		///	<summary>
		///	get(name[, defval]) - gets the value of parameter, uses defval if not found
		///	</summary>
		///	<param name="name" type="String">
		///	<param name="defval" type="Object">
		///	<returns type="String" />
		var result = this.p[name];
		return (result != null) ? result.join(",") : defval;
	},

	getValues: function(name) {
		///	<summary>
		///	getValues(name) - gets multiple values as array, or empty array
		///	</summary>
		///	<param name="name" type="String">
		///	<returns type="Array" />
		return (this.p[name] || []).concat();
	},

	add: function(name, value) {
		///	<summary>
		///	add(name, value) - adds a value
		///	<param name="name" type="String">
		///	<param name="value" type="Object">
		///	</summary>
		if(value != null)
			this.p[name] = (this.p[name] || []).concat(value);
		return this;
	},

	set: function(name, value) {
		///	<summary>
		///	set(name, value) - [re]sets single value
		///	</summary>
		///	<param name="name" type="String">
		///	<param name="value" type="Object">
		if(value != null)
			this.p[name] = [].concat(value);
		else
			delete this.p[name];
		return this;
	},

	remove: function(name) {
		///	<summary>
		///	remove(name) - removes value
		///	</summary>
		///	<param name="name" type="String">
		return this.set(name, null);
	},

	clear: function() {
		///	<summary>
		///	clear() - clears all values
		///	</summary>
		this.p = {};
		return this;
	},

	parse: function(qs) {
		///	<summary>
		///	parse([qs]) - parses query string
		///	</summary>
		/// <param name="qs" type="String">query string</param>
		this.clear();
		if(qs == null)
			qs = location.search;
		if(qs.length > 0 && qs.charAt(0) == "?")
			qs = qs.substring(1);
		if(qs.length === 0)
			return;
		var de = decodeURIComponent;
		var args = qs.split("+").join(" ").split("&");
		for(var i = 0; i < args.length; i++) {
			var arg = args[i].split("=");
			var name = de(arg[0]);
			var value = arg.length == 2 ? de(arg[1]) : "";
			this.add(name, value);
		}
		return this;
	},

	toString: function() {
		///	<summary>
		///	toString(qs) - returns query string
		///	</summary>
		///	<returns type="String" />
		var en = encodeURIComponent, result = [];
		this.each(function(k, v) {
			result.push(en(k) + "=" + en(v));
		});
		return result.join("&");
	}
};

$.qstring = Qstring;
